module.exports = __webpack_public_path__ + "home-block-6-overlay@2x-2_J8FID.png";